import { usePlatform } from "../PlatformContext";

export function useSignupDisabled() {
  const { isSignupDisabled } = usePlatform();
  return isSignupDisabled ?? false;
} 